var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cooking",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 53.771,
    viewBox: "0 0 57 53.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11262",
    "data-name": "Path 11262",
    d: "M142.916,292.239c-.805-3.424-3.486-5.029-6.85-5.621a19.022,19.022,0,0,0-2.406-.259,3.855,3.855,0,0,1-1.549-.35c-2.416,4.579-13.46,4.256-15.3,0v-.032a3.822,3.822,0,0,1-1.617.382,19.178,19.178,0,0,0-2.338.246c-3.27.56-5.9,2.068-6.821,5.255,1.419,1.362,12.946,11.754,13.036,12.323h24.2v-5.825a2.038,2.038,0,0,1,.725-1.557Zm0,0",
    transform: "translate(-94.227 -254.14)",
    fill: "#64b0d9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    "data-name": "Path 11263",
    d: "M64.679,225.447a.867.867,0,0,1-.6-1.487c.818-.8.642-1.14.219-1.968a2.994,2.994,0,0,1,.662-4.146.867.867,0,1,1,1.188,1.262c-.93.875-.747,1.232-.306,2.1a2.929,2.929,0,0,1-.553,4A.865.865,0,0,1,64.679,225.447Zm0,0",
    transform: "translate(-56.642 -193.384)",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    "data-name": "Path 11264",
    d: "M107.767,183.706a.867.867,0,0,1-.605-1.487c.818-.8.642-1.139.218-1.967a2.993,2.993,0,0,1,.66-4.147.867.867,0,0,1,1.189,1.262c-.929.875-.746,1.232-.3,2.094a2.928,2.928,0,0,1-.551,4,.866.866,0,0,1-.6.246Zm0,0",
    transform: "translate(-94.931 -156.29)",
    fill: "#666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M466.125,262.392a.866.866,0,0,1-.867-.866V247.375a.867.867,0,0,1,1.734,0v14.151A.867.867,0,0,1,466.125,262.392Zm0,0",
    transform: "translate(-413.462 -219.065)",
    fill: "#666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9542",
    "data-name": "Group 9542",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    "data-name": "Path 11266",
    d: "M169.635,286.358a19.184,19.184,0,0,0-2.338.246v5.255l1.756,1.576,2.2-1.576v-5.883A3.821,3.821,0,0,1,169.635,286.358Zm0,0",
    transform: "translate(-148.672 -254.139)",
    fill: "#e6e6e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    "data-name": "Path 11267",
    d: "M165.785,303.007h4.709a1.7,1.7,0,0,1,1.675,1.433h20.139l-1.543-8.928a1.718,1.718,0,0,0-1.6-1.6v-7.035a19.014,19.014,0,0,0-2.406-.259,3.852,3.852,0,0,1-1.549-.35v7.644H173.12c.026.194-5.925,8.517-7.335,9.1Zm0,0",
    transform: "translate(-147.328 -254.396)",
    fill: "#e6e6e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    "data-name": "Path 11268",
    d: "M216.236,254.081l-5.508-1.738-6.064,1.705-.016.029a4.092,4.092,0,0,1-1.824,2.01v.033c1.843,4.255,12.888,4.579,15.3,0A4.252,4.252,0,0,1,216.236,254.081Zm0,0",
    transform: "translate(-180.244 -224.251)",
    fill: "#fcc368",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11269",
    "data-name": "Path 11269",
    d: "M194.4,115.132a44.7,44.7,0,0,0-13.234,0q-1.921.286-3.845.745v8.437c0,2.987,2.176,5.625,4.68,7.362a10.588,10.588,0,0,0,5.766,2.165,11.943,11.943,0,0,0,5.805-2.133c2.626-1.793,4.709-4.576,4.709-7.844v-7.99q-1.935-.452-3.881-.741Zm0,0",
    transform: "translate(-157.579 -101.877)",
    fill: "#ffdda6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11270",
    "data-name": "Path 11270",
    d: "M172.729,0a5.842,5.842,0,0,0-5.207,3.1h-2.84c-4.1,0-6.549,4.511-2.707,6.9v6.275q1.926-.456,3.846-.744a44.666,44.666,0,0,1,13.234,0q1.945.291,3.881.744V10.006c3.842-2.391,1.5-6.9-2.6-6.9h-3.053A4.473,4.473,0,0,0,172.767,0Zm0,0",
    transform: "translate(-142.235)",
    fill: "#e6e6e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    "data-name": "Path 11271",
    d: "M325.7,34.778c3.842-2.391,1.5-6.9-2.6-6.9h-2.4c3.68,0,5.954,3.291,3.606,5.767-.754.793-.993.382-.993,1.492l-.01,5.42q1.2.219,2.393.5Zm0,0",
    transform: "translate(-285.003 -24.772)",
    fill: "#c2c7cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M260.959,175.267a5.848,5.848,0,0,1-2.393-1.087v2.1c0,3.268-2.086,6.055-4.712,7.844a11.914,11.914,0,0,1-5.805,2.133c-.065,0-.13.007-.2.007a6.933,6.933,0,0,0,2.594.492,11.942,11.942,0,0,0,5.805-2.133c2.626-1.793,4.709-4.576,4.709-7.845Zm0,0",
    transform: "translate(-220.259 -154.788)",
    fill: "#fcc368",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M297.8,269.992a4.25,4.25,0,0,1-1.892-2.039,13.219,13.219,0,0,1-3.431,1.679,4.327,4.327,0,0,0,2.516,2.236,3.336,3.336,0,0,0,.6.217A5.209,5.209,0,0,0,297.8,269.992Zm0,0",
    transform: "translate(-259.912 -238.123)",
    fill: "#eda93b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M333.46,292.5c-.805-3.424-3.486-5.029-6.85-5.621a19.023,19.023,0,0,0-2.406-.259,3.855,3.855,0,0,1-1.549-.35,5.209,5.209,0,0,1-2.209,2.094,4.065,4.065,0,0,0,.951.133c.427.023.844.052,1.258.1.391.042.773.094,1.149.162a12.159,12.159,0,0,1,2.807.825,6.743,6.743,0,0,1,4.046,4.8,41.845,41.845,0,0,1,1.125,10.064h2.031v-5.825a2.038,2.038,0,0,1,.724-1.557Zm0,0",
    transform: "translate(-284.771 -254.396)",
    fill: "#4a83c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M344.24,286.874a19.022,19.022,0,0,0-2.406-.259,3.855,3.855,0,0,1-1.549-.35v2.324c.391.042.773.094,1.148.162a12.158,12.158,0,0,1,2.807.825Zm0,0",
    transform: "translate(-302.401 -254.396)",
    fill: "#c2c7cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M447.752,382.5a3.634,3.634,0,0,0-3.622-3.624h-1.585a2.042,2.042,0,0,0-2.037,2.039v6.553a2.047,2.047,0,0,0,2.037,2.042h1.585a3.634,3.634,0,0,0,3.622-3.624Zm0,0",
    transform: "translate(-391.467 -336.699)",
    fill: "#ffdda6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M440.267,141.621h-3.68a2.505,2.505,0,0,0-2.5,2.5v7.546a2.5,2.5,0,0,0,2.5,2.5h3.68a2.507,2.507,0,0,0,2.5-2.5v-7.547a2.512,2.512,0,0,0-2.5-2.5Zm0,0",
    transform: "translate(-385.763 -125.855)",
    fill: "#e6e6e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M359.033,356.528a1.717,1.717,0,0,0-1.6-1.6h-2.3l1.885,10.53h3.558Zm0,0",
    transform: "translate(-315.596 -315.413)",
    fill: "#c2c7cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M459.162,382.5a3.634,3.634,0,0,0-3.622-3.624h-1.585a2.013,2.013,0,0,0-.608.094,3.638,3.638,0,0,1,2.8,3.531v3.385a3.64,3.64,0,0,1-2.8,3.531,2.115,2.115,0,0,0,.608.094h1.585a3.634,3.634,0,0,0,3.622-3.625Zm0,0",
    transform: "translate(-402.877 -336.699)",
    fill: "#fcc368",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M231.463,340.613a2.072,2.072,0,0,0-2.047-1.793h-3.473c-1.219,0-1.426,1.149-1.688,2.33-.133.589,2.529,1.252,2.319,1.8h2.843a2.07,2.07,0,0,0,2.067-2.065A1.913,1.913,0,0,0,231.463,340.613Zm0,0",
    transform: "translate(-199.285 -301.1)",
    fill: "#fcc368",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M5.537,338.82H2.063a2.066,2.066,0,0,0,0,4.133H4.9L7.593,340.4Zm0,0",
    transform: "translate(0 -301.1)",
    fill: "#fcc368",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M56.815,338.82H39.772c-1.219,0-1.407,1.236-1.145,2.421a12.944,12.944,0,0,0,.508,1.712,11.534,11.534,0,0,0,6.649,6.757l3.936,2.459,5.255-2.459a11.985,11.985,0,0,0,7.063-8.469c.262-1.184.078-2.421-1.145-2.421Zm0,0",
    transform: "translate(-34.235 -301.1)",
    fill: "#f78411",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M66.225,436.637H52.878a1.7,1.7,0,0,0-1.695,1.7v1.77a1.7,1.7,0,0,0,1.695,1.7H70.934a1.7,1.7,0,0,0,1.695-1.7v-1.77a1.421,1.421,0,0,0-.023-.262,1.7,1.7,0,0,0-1.672-1.433Zm0,0",
    transform: "translate(-45.485 -388.027)",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11284",
    "data-name": "Path 11284",
    d: "M163.972,338.82h-3.535c1.219,0,1.407,1.236,1.145,2.421a12.063,12.063,0,0,1-3.334,6c-.052.049-.1.1-.155.149a11.737,11.737,0,0,1-3.577,2.317h3.538a11.588,11.588,0,0,0,1.811-.942,12.012,12.012,0,0,0,5.252-7.527,3.862,3.862,0,0,0,.094-.628c.071-.955-.233-1.793-1.239-1.793Zm0,0",
    transform: "translate(-137.314 -301.1)",
    fill: "#f74311",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11285",
    "data-name": "Path 11285",
    d: "M202.018,438.07a1.7,1.7,0,0,0-1.672-1.433h-3.538a1.7,1.7,0,0,1,1.676,1.433,1.8,1.8,0,0,1,.019.262v1.77a1.7,1.7,0,0,1-1.695,1.7h3.538a1.7,1.7,0,0,0,1.695-1.7v-1.77A1.383,1.383,0,0,0,202.018,438.07Zm0,0",
    transform: "translate(-174.898 -388.027)",
    fill: "#666",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M464.467,142.537a2.5,2.5,0,0,0-1.924-.916h-3.386a2.508,2.508,0,0,1,2.5,2.5v7.546a2.505,2.505,0,0,1-2.5,2.5h3.386a2.507,2.507,0,0,0,2.5-2.5V144.12A2.482,2.482,0,0,0,464.467,142.537Zm0,0",
    transform: "translate(-408.039 -125.855)",
    fill: "#c2c7cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M334.328,140.3q-1.935-.456-3.881-.744c-.456,4.11,3.622,4.9,3.881,4.941Zm0,0",
    transform: "translate(-293.627 -124.022)",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M181.165,139.559q-1.921.291-3.845.744v4.191C177.879,144.384,181.6,143.484,181.165,139.559Zm0,0",
    transform: "translate(-157.579 -124.022)",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M346.487,142.264q-1.193-.281-2.393-.5v3.608a5.851,5.851,0,0,0,2.393,1.088Zm0,0",
    transform: "translate(-305.787 -125.983)",
    fill: "#666",
    fillRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M217.367,171.365a.867.867,0,0,1-.619-1.474,3.15,3.15,0,0,1,2.125-.708h.017a3.186,3.186,0,0,1,2.149.7.867.867,0,1,1-1.23,1.222,2.305,2.305,0,0,0-1.824,0A.861.861,0,0,1,217.367,171.365Zm0,0",
    transform: "translate(-192.397 -150.349)",
    fill: "#666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M280.432,171.365a.867.867,0,0,1-.619-1.474,3.151,3.151,0,0,1,2.125-.708h.017a3.187,3.187,0,0,1,2.149.7.867.867,0,1,1-1.23,1.222,2.3,2.3,0,0,0-1.823,0A.862.862,0,0,1,280.432,171.365Zm0,0",
    transform: "translate(-248.442 -150.349)",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M263.387,47.694a.867.867,0,0,1-.867-.867v-3.98a.867.867,0,0,1,1.734,0v3.98A.867.867,0,0,1,263.387,47.694Zm0,0",
    transform: "translate(-233.294 -37.307)",
    fill: "#c2c7cc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M210.516,63.855a.867.867,0,0,1-.867-.867V59.011a.867.867,0,0,1,1.734,0v3.977A.867.867,0,0,1,210.516,63.855Zm0,0",
    transform: "translate(-186.309 -51.672)",
    fill: "#c2c7cc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M316.258,63.855a.867.867,0,0,1-.867-.867V59.011a.867.867,0,0,1,1.734,0v3.977A.867.867,0,0,1,316.258,63.855Zm0,0",
    transform: "translate(-280.279 -51.672)",
    fill: "#c2c7cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionIcon);
export default __webpack_public_path__ + "static/media/production-icon.64b343706090703bc418de33023128d5.svg";
export { ForwardRef as ReactComponent };